export default __webpack_public_path__ + "static/media/30.81ddf6d7.png";